<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showIndex="true"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'applypc',
      formInline: { isaudit: 1 },
      formCtrl: [
        {
          label: '提交人：',
          keyName: "applyname",
          placeholder: "请填写搜索内容",
          type: "text",
        },
      ],
      cols: [
        { prop: "title", label: "标题" },
        { prop: "applyname", label: "提交人" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/matterReview/detail?id=${id}`
            );
          },
        },
      ],
      baseParams: ['isaudit'],
    };
  },
  methods: {},
  mounted() {
    this.getList();
  },
};
</script>
